module.exports = __webpack_public_path__ + "static/media/pulmonology-image-1@3x.3e381319.png";